// extracted by css-extract-rspack-plugin
export default {"colorLightGray":"#f7f7f7","colorLightBlue":"#05a6e4","colorClickable":"rgba(92, 52, 205, 1)","moduleRow":"modules__moduleRow___mngg2"};